module.exports = __webpack_public_path__ + "static/media/photo-3.815aea26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-remodelling/photo-3.jpg
// module id = 173
// module chunks = 0